import React from 'react';
import PropTypes from 'prop-types';

import cx from 'classnames';
import styles from '../../containers/checkoutPage/CheckoutPage.m.sass';


import {reduxForm, Field, FormSection} from 'redux-form';
import FieldText from '../fields/fieldText/FieldText';
import Button from '../button/Button';
import cartIcon from '../button/assets/cart.svg';
import CharacterFields from './CharacterFields';
import ContactFields from './ContactFields';
import CheckoutCartSummary from './CheckoutCartSummary';
import PaymentMethodField from './PaymentMethodField';
import CheckoutCouponSubform from './CheckoutCouponSubform';


@reduxForm({
  form: 'checkout'
})
export default class CheckoutForm extends React.PureComponent {
  componentDidMount() {
    const {cart, change} = this.props;

    change('paymentMethod', cart.payments[cart.payments.length - 1].methodsAvailable[0].code);
    change('customer.contact_method', 'skype');
    change('details.Faction', 'Alliance');
  }

  render() {
    const {cart, applyCoupon, removeCoupon, handleSubmit, submitting, error} = this.props;

    return (
      <form className={styles.checkout_row} onSubmit={handleSubmit}>
        <div className={styles.checkout_col}>
          <div className={styles.checkout_colInner}>
            <div className={styles.checkout_colGradient}>
              <div className={styles.checkout_form}>

                <FormSection name="details">
                  <CharacterFields/>
                </FormSection>

                <FormSection name="customer">
                  <ContactFields/>
                </FormSection>

                <fieldset className={styles.checkout_group}>
                  <legend className={styles.checkout_legend}>Additional Information</legend>

                  <Field
                    component={FieldText}
                    type="text"
                    label="Order Notes (Optional)"
                    placeholder="Preferable day and time, your main spec, preferable contact method, other info"
                    name="additional_info"
                  />
                </fieldset>
              </div>
            </div>
          </div>
        </div>

        <div className={styles.checkout_col}>
          <div className={styles.checkout_colInner}>
            <div className={styles.checkout_colGradient}>

              <CheckoutCartSummary
                items={cart.items}
                subtotal={cart.total - cart.promotionTotal}
                total={cart.total}
              />

              <div className={styles.checkout_payments}>
                <Field
                  name="paymentMethod"
                  methods={cart.payments[cart.payments.length - 1].methodsAvailable}
                  component={PaymentMethodField}
                />

                <div className={styles.checkout_actions}>
                  <div className={styles.checkout_actionItem}>
                    <Field
                      name="discount"
                      label="Coupon Code"
                      type="text"
                      placeholder="00 00 000000"
                      component={CheckoutCouponSubform}
                      coupon={cart.promotionCoupon && cart.promotionCoupon.code}
                      applyCoupon={applyCoupon}
                      removeCoupon={removeCoupon}
                    />
                  </div>
                  <div className={cx(styles.checkout_actionItem, styles.checkout_actionItem__submit)}>
                    <Button
                      icon={cartIcon}
                      iconPosition="left"
                      disabled={submitting}
                      full
                    >
                      Proceed to payment
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    );
  }
}



// WEBPACK FOOTER //
// ./components/checkout/CheckoutForm.js